import React, { useCallback, useState } from 'react';
import { InputAccessoryView, Platform, StyleSheet, View } from 'react-native';

import { Button, EmailInput } from '@fhs/ui';
import { EMAIL_INPUT_ACCESSORY_ID } from '@fhs/ui/src/components/form-text-inputs/name-input';

import { AuthIdentifiers, useAuthV2Context } from '../context';
import { checkIdentifierValidity } from '../utils';

export const ContinueWithEmail = () => {
  const { createOtp, loading } = useAuthV2Context();
  const [loginIdentifier, setLoginIdentifier] = useState<string>();
  const [error, setError] = useState<boolean>(false);

  const onInputChange = useCallback(
    input => {
      setLoginIdentifier(input);
      setError(false);
    },
    [setLoginIdentifier, setError]
  );

  const attemptLogin = useCallback(async () => {
    if (checkIdentifierValidity({ loginIdentifier, identifierType: AuthIdentifiers.EMAIL })) {
      await createOtp({
        loginIdentifier,
        identifierType: AuthIdentifiers.EMAIL,
      });
    } else {
      setError(true);
    }
  }, [createOtp, loginIdentifier]);
  return (
    <>
      <EmailInput value={loginIdentifier} onChange={onInputChange} error={error} autoFocus />
      {Platform.OS !== 'ios' ? (
        <View>
          <Button
            size="md"
            style={styles.continueButton}
            onPress={attemptLogin}
            loading={loading}
            disabled={loading}
          >
            <Button.Text>Continue</Button.Text>
          </Button>
        </View>
      ) : (
        <InputAccessoryView nativeID={EMAIL_INPUT_ACCESSORY_ID}>
          <Button
            loading={loading}
            disabled={loading}
            size="md"
            style={{ ...styles.continueButton, width: '85%' }}
            onPress={attemptLogin}
          >
            <Button.Text>Continue</Button.Text>
          </Button>
        </InputAccessoryView>
      )}
    </>
  );
};

const styles = StyleSheet.create({
  continueButton: {
    height: 48,
    width: '100%',
    marginVertical: 12,
    alignSelf: 'center',
  },
});
